import React from 'react';
import { useDiagramStore } from '../stores/diagramStore';

const ReadOnlyBanner: React.FC = () => {
  const { isReadOnly, lockedBy } = useDiagramStore();

  if (!isReadOnly) return null;

  return (
    <div className="bg-yellow-100 border-b border-yellow-300 px-4 py-2">
      <div className="flex items-center justify-center">
        <div className="flex items-center gap-2">
          <svg 
            className="w-5 h-5 text-yellow-600" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" 
            />
          </svg>
          <span className="text-yellow-800 font-medium">
            Viewing in read-only mode
          </span>
          {lockedBy && (
            <span className="text-yellow-700">
              • {lockedBy} is currently editing
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReadOnlyBanner;